import {shallowEqual} from 'react-redux';
import {useAppSelector} from './useRedux';

export default function useQueryContext() {
    return useAppSelector((state) => state.query.context, shallowEqual);
}
